/* eslint-disable @typescript-eslint/no-explicit-any */
import { Navigate, Route, Routes } from 'react-router-dom'

import { constants, links, paths } from 'apps'
import { useAppSelector, useLocalStorage } from 'hooks'
import { CommonLayout } from 'layouts'
import { useEffect } from 'react'
import { PrivateRoute } from 'routes'
import { handleAsyncRequest } from 'utils/helper'
import { getSignerByProvider } from 'utils/metamask'
import {
  CreateGuild,
  GuildDetail,
  GuildFarm,
  GuildMain,
  Information,
  Manage,
  Members,
  YourFarm,
  ManagementApplication,
  ManagementUserBlacklist,
  ManagementHorseBlacklist,
  ManagementDetail,
} from './pages'
// import Condition from './pages/Condition'
import GuildList from './pages/GuildList'
import GuildMemberDetail from './pages/GuildMemberDetail'
import HorseOwner from './pages/HorseOwner'
import InCome from './pages/Income'
import UpdateInfo from './pages/UpdateInfo'
import MyHorses from './pages/MyHorses'
import DisbandGuild from './pages/DisbandGuild'
import ManagementBalance from './pages/ManagementBalance'
import { useAvailableWallet } from 'features/Auth/pages/Main/useAvailableWallet'
import UpgradeGuild from './pages/UpgradeGuild'
import GuildRace from './pages/GuildRace'
import VaultSetting from './pages/VaultSetting'
import GuildVault from './pages/GuildVault'
import JoinRequirement from './pages/JoinRequirement'
import Ranking from './pages/Ranking'

function Guild() {
  const [, setUserId] = useLocalStorage(constants.USER_ID_KEY, 0)
  const [, setAccessToken] = useLocalStorage(constants.ACCESS_TOKEN_KEY, null)
  const [, setRefreshToken] = useLocalStorage(constants.REFRESH_TOKEN_KEY, null)
  const auth = useAppSelector(state => state.auth)
  const providers = useAvailableWallet();
  const storedWalletName = localStorage.getItem("walletName");

  const matchedProviderDetail = providers.find(
    (p) => p.info.name === storedWalletName
  );
  const ethereumProvider = matchedProviderDetail?.provider ?? window.ethereum;

  const checkSignerProfile = async () => {
    const [signerError] = await handleAsyncRequest(getSignerByProvider(ethereumProvider))
    if (signerError) {
      setUserId(0)
      setAccessToken('')
      setRefreshToken('')
    }
  }
  useEffect(() => {
    if (providers?.length) {
      checkSignerProfile()
    }
  }, [providers])
  return (
    <Routes>
      <Route
        path={paths.default()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <GuildMain />
          </PrivateRoute>
        }
      >
        <Route path={paths.guild.createGuild()} element={<CreateGuild />} />
        <Route path={paths.guild.joinGuild()} element={<GuildList />} />
        <Route path={paths.guild.information()} element={<Information />} />
        <Route path={paths.guild.members()} element={<Members />} />
        <Route path={paths.guild.membersId()} element={<Members />} />
        <Route path={paths.guild.guildFarm()} element={<GuildFarm />} />
        <Route path={paths.guild.guildFarmId()} element={<GuildFarm />} />
        <Route path={paths.guild.yourHorse()} element={<YourFarm />} />
        <Route path={paths.guild.manage()} element={<Manage />} />
        {/* <Route path={paths.guild.detail()} element={<HorseDetail />} /> */}
        <Route path={paths.guild.detail()} element={<GuildDetail />} />
        <Route path={paths.guild.detailMember()} element={<GuildMemberDetail />} />
        <Route path={paths.guild.informationDetail()} element={<Information />} />
        <Route path={paths.guild.horseOwner()} element={<HorseOwner />} />
        <Route path={paths.guild.horseOwnerId()} element={<HorseOwner />} />
        <Route path={paths.guild.updateInfo()} element={<UpdateInfo />} />
        <Route path={paths.guild.inCome()} element={<InCome />} />
        {/* <Route path={paths.guild.entryCondition()} element={<Condition />} /> */}
        <Route path={paths.guild.disbandGuild()} element={<DisbandGuild />} />
        <Route path={paths.guild.upgrade()} element={<UpgradeGuild />} />
        <Route path={paths.guild.guildList()} element={<GuildList />} />
        <Route path={paths.guild.detailOwner()} element={<GuildMemberDetail />} />
        <Route path={paths.guild.myHorses()} element={<MyHorses />} />
        <Route path={paths.guild.myProfile()} element={<GuildMemberDetail />} />
        <Route path={paths.guild.horseDetailInfarm()} element={<GuildDetail />} />
        <Route path={paths.guild.horseDetail()} element={<GuildDetail />} />
        <Route path={paths.guild.applicationGuild()} element={<ManagementApplication />} />
        <Route path={paths.guild.guildRace()} element={<GuildRace />} />
        <Route path={paths.guild.joinRequirements()} element={<JoinRequirement />} />
        <Route path={paths.guild.vaultSetting()} element={<VaultSetting />} />
        <Route path={paths.guild.ranking()} element={<Ranking />} />
        <Route path={paths.guild.guildVault()} element={<GuildVault />} />
        <Route path={paths.guild.applicationDetailMember()} element={<ManagementDetail />} />
        <Route path={paths.guild.userBlacklistGuild()} element={<ManagementUserBlacklist />} />
        <Route path={paths.guild.userBlacklistDetail()} element={<ManagementDetail />} />
        <Route path={paths.guild.horseBlacklistGuild()} element={<ManagementHorseBlacklist />} />
        <Route path={paths.guild.horseBlacklistDetail()} element={<ManagementDetail />} />
        <Route path={paths.guild.BalanceGuild()} element={<ManagementBalance />} />
      </Route>
      <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} />
    </Routes>
  )
}


export default Guild
